<template>
    <div class="all-users">
        <div class="users__page__title">
            My Users
        </div>
        <div class="page-sub-menu" v-if="isLoaded">
            <div
                class="VSearch"
            >
                <span class="VSearch-icon">
                </span>
                <VInput
                    v-model.trim="search"
                    :placeholder="'Type something...'"
                >
                </VInput>
            </div>
            <div
                class="button"
                @click="addNewUser"
            >
                <div class="icon">
                    +
                </div>
                <div class="text">
                    ADD NEW USER
                </div>
            </div>
        </div>
        <div
            v-if="!isLoading && users.length"
            class="users__table table"
        >
            <div class="table__header">
                <div class="table__header__item">
                    name
                </div>
                <div class="table__header__item">
                    email
                </div>
                <div class="table__header__item">
                    Applications
                </div>
                <div class="table__header__item">
                    Attributes
                </div>
                <div class="table__header__item">
                    Events
                </div>
                <div class="table__header__item"></div>
            </div>
            <Row
                v-for="(user, userIndex) in filteredUsers"
                :key="userIndex"
                :user="user"
                @editUser="editUser(user)"
                @addNewUser="addNewUser"
                @deleteUser="deleteUser(user)"
            />
        </div>
        <div
            v-if="isLoading"
            class="users__table_loading table"
        >
            <div class="table__header">
                <div class="table__header__item">
                    name
                </div>
                <div class="table__header__item">
                    email
                </div>
                <div class="table__header__item">
                    Applications
                </div>
                <div class="table__header__item">
                    Attributes
                </div>
                <div class="table__header__item">
                    Events
                </div>
                <div class="table__header__item"></div>
            </div>
            <div class="loading-row" v-for="n in 10" :key="n"></div>
        </div>
    </div>
</template>

<script>
    import Row from './AllUsers/Row';
    
    export default {
        name: 'AllUsers',
        components: {
            Row,
        },
        props: {
            users: {
                type: Array,
                required: true,
                default: () => ([]),
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
            isLoaded: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                search: '',
            };
        },
        computed: {
            filteredUsers() {
                return this.users.filter((user) => {
                    if (this.search.length) {
                        return (user.profilename &&
                            user.profilename.trim().toLowerCase().includes(this.search.trim().toLowerCase())) ||
                            (user.email &&
                            user.email.trim().toLowerCase().includes(this.search.trim().toLowerCase()));
                    }
                    return true;
                });
            },
        },
        methods: {
            editUser(user) {
                this.$emit('editUser', user);
            },
            addNewUser() {
                this.$emit('addNewUser');
            },
            deleteUser(user) {
                this.$emit('deleteUser', user, user.profilename);
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    @import "../../scss/base/colors";
    @import "../../scss/base/shadow";
    
    .loading-row{
        margin-bottom: 10px;
        margin-top: 10px;
        height: 40px;
        background: #E4ECFF;
        border-radius: 2px;
        @include loading-animation;
    }
    
    .users__page__title {
        font-size: 16px;
        line-height: 20px;
        font-weight: 700;
        text-align: left;
        margin-bottom: 15px;
    }
    
    .page-sub-menu {
        display: flex;
        justify-content: space-between;
        width: 880px;
        margin-bottom: 20px;
        
        .VSearch {
            pointer-events: none;
            width: 337px;
            height: 40px;
            border: 1px solid $primary-color;
            padding-left: 12px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            
            &-icon {
                pointer-events: all;
                width: 19px;
                height: 18px;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url('data:image/svg+xml;base64,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');
            }
            
            ::v-deep {
                .VInput {
                    pointer-events: all;
                    input {
                        font-family: Quicksand;
                        font-size: 15px;
                        border: none;
                        width: 300px;
                        border-radius: 4px;
                        padding-left: 10px;
                        
                        &::placeholder {
                            font-style: italic;
                            font-weight: 400;
                        }
                    }
                    
                }
            }
            
        }
        
        .button {
            display: flex;
            align-items: center;
            color: $primary-color;
            font-weight: 600;
            cursor: pointer;
            padding-right: 8px;
            
            .icon {
                font-weight: 400;
                font-size: 30px;
                margin-right: 5px;
            }
        }
    }
    
    .table {
        width: 880px;
        border-radius: 10px;
        @include dark-shadow;
        
        &__header {
            height: 45px;
            border-bottom: 1px solid $primary-color;
            display: grid;
            grid-template-columns: 1.7fr 2.33fr 1.73fr 1.2fr 1.3fr 1fr;
            padding: 0 22px;
            font-weight: 600;
            
            &__item {
                text-align: left;
                padding-top: 21px;
                padding-bottom: 8px;
            }
        }
    }
</style>